export default "__VITE_ASSET__ByLiM2MO__"